module.exports = __webpack_public_path__ + "img/Listening_to_molecule.12480dc6.gif";